import { Box, Typography } from '@mui/material'
import React from 'react'
import welcome from '../../Assets/img/hand.png'

const FooterSecComp = ({topic , header  , section , points , pointHead , image}) => {
  return (
    <div className='text-black'>
        
        {topic && 
        <Box sx={{ width:'60%' , margin:'auto'}}>
            <Typography variant='h3' className='text-center' sx={{fontSize:'25px' , fontWeight:600  , padding:'10px' , backgroundColor:'#004878' , color:'white' , borderRadius:'15px' , margin :'20px 0'}}>
                {topic}
            </Typography>
        </Box>
        }
        {image && (
            <Box
              sx={{
                // float: 'left',
                marginRight: '20px',
                marginBottom: '10px',
                // shapeOutside: 'margin-box'
              }}
            >
              <img
                src={image}
                alt=""
                style={{
                  maxWidth: '100px',
                  height: 'auto',
                  borderRadius: '4px' // Optional: for rounded corners
                }}
              />
            </Box>
          )}
        <Typography variant='h4'  sx={{fontSize:'20px' , fontWeight:600 , margin:'20px 0 10px 0' , color:'#004878'}}>{header}</Typography>
        {(points || pointHead) && 
            <>
                {pointHead && <Typography variant='h4'  sx={{fontSize:'16px' , fontWeight:600 , margin:'20px 0 10px 0'}}>{pointHead}</Typography>}
                {points && <ul>
                    {points.map((poi, i) => (
                        Array.isArray(poi) ? (
                        poi.map((p, j) => (
                            <li className='list-disc ml-20' key={`${i}-${j}`}>{p} <br /></li>
                        ))
                        ) : (
                        <li className='list-disc ml-10' key={i}>{poi}</li>
                        )
                    ))}
                </ul>}
            </>
        }
        {(section || image) && (
        <Box sx={{ overflow: 'hidden' }}> {/* Ensures container wraps floated elements */}
          
          {section && section.map((ele, i) => (
            <div className='flex gap-1' key={i}>
              <Typography
                
                variant='h3'
                sx={{
                  fontSize: '15px',
                  fontWeight: 400,
                  margin: '0 0 10px 0',
                  textAlign: 'justify',
                  lineHeight: 1.6
                }}
              >
                {ele}
              </Typography>
              {ele === 'Namaste! ' && <img src={welcome} alt=""  className='mb-[10px] w-[16px] '/>}
            </div>
          ))}
        </Box>
      )}
    </div>
  )
}

export default FooterSecComp